<div class="header" [class.mobile]="navigationService.useMobileNav$ | async">
    <button class="header-action" (click)="toggleOpen()"
            [ngClass]="{'mobile': navigationService.useMobileNav$ | async, 'active':isOpen}">
        <div class="header-action-media"
             [ngClass]="{'mobile': navigationService.useMobileNav$ | async, 'active':isOpen}">
            <fui-icon class="header-action-media-object" [height]="8" [icon]="'chevron-right'"
                      id="toggle-icon" [width]="6"></fui-icon>
        </div>
        <div class="header-action-label" [class.mobile]="navigationService.useMobileNav$ | async">
            <div class="header-action-label-title" id="toggle-title">
                {{ group.title | translate }}
            </div>
        </div>
    </button>
</div>
@if (isOpen) {
    <div class="links" [class.mobile]="navigationService.useMobileNav$ | async" [@toggle]>
        @for (link of group.links; track link; let index = $index) {
            @if (!link.links && (link.availability | async) !== FUINavigationLinkAvailability.UNAVAILABLE) {
                <fui-navigation-link id="link-{{index}}" [link]="link"></fui-navigation-link>
            }
            @if (link.links && (link.availability | async) !== FUINavigationLinkAvailability.UNAVAILABLE) {
                <fui-navigation-group id="group-{{index}}" [group]="link"></fui-navigation-group>
            }
        }
    </div>
}



